import { render, staticRenderFns } from "./BubbleTabs.vue?vue&type=template&id=fe02be6a&scoped=true"
import script from "./BubbleTabs.vue?vue&type=script&lang=ts"
export * from "./BubbleTabs.vue?vue&type=script&lang=ts"
import style0 from "./BubbleTabs.vue?vue&type=style&index=0&id=fe02be6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe02be6a",
  null
  
)

export default component.exports